module.exports = __webpack_public_path__ + "static/setting-notification-c9bc7861a208202edbb4e92e3accf9ff.png";